import { BlockEntityMapper } from '../block/entityMapper'
import { SiteEntityMapper } from './entityMapper'
import { ApiSiteInfo } from './apiTypes'
import { BaseRepository } from '~/passporter-services/baseRepository'
import { Block2 } from '~/models/Block'
import { Destination2 } from '~/models/Destination'
import { Site2 } from '~/models/Site'
import Product, { PRODUCT_CATEGORY } from '~/models/Product'
import { SiteInfo2 } from '~/models/SiteInfo'
import { Spot2 } from '~/models/Spot'
import { SpotEntityMapper } from '../spot/entityMapper'
import { ApiProduct } from '../product/apiType'
import { ProductEntityMapper } from '../product/entityMapper'
import { ApiPage } from '../shared/pagination'

export class SiteRepository extends BaseRepository {
	static readonly resource = 'v1/sites'

	static async getSite(siteId: string): Promise<Site2> {
		const response: any = await this.get(`${this.resource}/${siteId}/`)
		return SiteEntityMapper.toSite(response)
	}

	static async getSiteBySubdomain(subdomain: string): Promise<Site2> {
		const response: any = await this.get(`${this.resource}/`, { subdomain })
		return SiteEntityMapper.toSite(response)
	}

	static async getDestinationBlocks(id: string): Promise<Block2<Destination2>[]> {
		const response: any = await this.get(`${this.resource}/${id}/blocks/`, {
			page: 0,
			page_size: 10,
			type: 'destination',
		})
		return BlockEntityMapper.toBlocks(response.results) as Block2<Destination2>[]
	}

	static async getProducts(siteId: string): Promise<Block2<Product>[]> {
		const params = { type: 'product' }
		const response: any = await this.get(`${this.resource}/${siteId}/blocks/`, params)
		if (!response.results && !response.results.length) return []

		return BlockEntityMapper.toBlocks(response.results) as Block2<Product>[]
	}

	static async getRecommendedSpots(siteId: string): Promise<Spot2[]> {
		const params = { page: 0, page_size: 4 }
		const response: any = await this.get(
			`${this.resource}/${siteId}/spots/recommendations/`,
			params
		)
		if (!response.results && !response.results.length) return []
		return SpotEntityMapper.toSpots(response.results) as Spot2[]
	}

	static async getSiteInfos(siteId: string): Promise<SiteInfo2[]> {
		const response: ApiSiteInfo[] = await this.get(`${this.resource}/${siteId}/info/`)
		return SiteEntityMapper.toInfos(response)
	}

	static async getProductsByCategory(
		siteId: string,
		category: PRODUCT_CATEGORY
	): Promise<Product[]> {
		const response: ApiPage<ApiProduct> = await this.get(`${this.resource}/${siteId}/products/`, {
			category,
			page: 0,
			page_size: 10,
		})
		return ProductEntityMapper.toProducts(response.results)
	}
}
